enum ThemeModeEnum {
  light = 'light',
  dark = 'dark',
  system = 'system',
}

export { ThemeModeEnum };
